export default function getAllRulesKeysReducer(state=[], action) {
    switch(action.type){
        case "get_rules_suc": {
            return action.payload.keys
        }
        default: {
            return state
        }
    }
}